









import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../../../../../domain/drawing";
import { default as MediaSelectableContentMixin } from "./mixins/MediaSelectableContentMixin.vue";
import { FatalIndicator } from "./common";
import { IExecutable } from "./IExecutable";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentImageSignInput extends Mixins(MediaSelectableContentMixin) implements IExecutable {
  get text(): string {
    const text = instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : null;
    return text ? text : "署名";
  }

  async execute() {
    if (this.$configuration.behavior.document.editor.objects.sign.signTablet.isEnable) {
      // TODO: サインタブレットとiPad/Androidタブレット上でのサインを併用する案件があれば検討が必要
      this.$warn("署名", "サインタブレットを使用する設定のため、処理スキップします。");
    } else {
      const result = await this.commonComponents.dialogs.sign.show(new Size(202, 45));
      if (result) {
        this.uploadImageFile(result);
      }
    }
  }
}
